import { useHistory } from "react-router-dom";

const NotFound: React.FC = () => {
  const history = useHistory();

  return (
    <>
      <section
        style={{
          backgroundImage: `${
            import.meta.env.REACT_APP_STATIC_URL
          }/images/404-bg.png`,
        }}
        className="es-small-hero normal-nav"
      >
        <div className="-container">
          <div className="-content">
            <div className="title -main">
              <span>404 - Page Not Found</span>
            </div>
          </div>
        </div>
      </section>

      <main style={{ margin: "0 auto" }}>
        <section className="es-default-text">
          <div className="text">
            <p>
              We&apos;re sorry, we couldn&apos;t find the page you were looking
              for, either it doesn&apos;t exist or an error has occurred.{" "}
              <span className="as-link" onClick={() => history.goBack()}>
                Go back
              </span>{" "}
              or return to the <a href="/">homepage</a>.
            </p>
          </div>
        </section>
      </main>
    </>
  );
};

export default NotFound;
